var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallingWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.81701 3.24205C3.71912 4.23466 3.92377 3.08632 4.49814 3.71805C5.05189 4.32735 5.37015 4.44942 4.66856 5.22139C4.58068 5.29912 4.02233 6.2343 2.06008 4.07519C0.0975789 1.91581 0.946764 1.30064 1.01741 1.20394C1.72069 0.429838 1.82969 0.782166 2.38344 1.39146C2.95781 2.02346 1.9149 2.24944 2.81701 3.24205Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallingWhite);
export default __webpack_public_path__ + "static/media/CallingWhite.77589ef848b6370cb693c5657c0bb2bb.svg";
export { ForwardRef as ReactComponent };